import {Swiper} from '../bootstrap'

window.addEventListener('load', function () {

    const usageSlider = new Swiper('.usage-slider', {
        loop: true,
        slidesPerView: 1,
        loopAdditionalSlides: 3,
        spaceBetween: 25,
        updateOnWindowResize: true,
        allowTouchMove: true,
        watchOverflow: true,
        observer: true,
        navigation: {
            prevEl: '.usage-slider__arrow--prev',
            nextEl: '.usage-slider__arrow--next',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 40
            }
        },
        on: {

        }
    })
})

